import { title } from 'process'
import './TitleBar.css'
import { CustomerType } from '../../../Configurator/Enums/CustomerType'
import { PackageCustomerType } from '../../Enums/PackageCustomerType'

interface Props
{
	title: String
    imageSrc: String
    customerType: String
}

const TitleBar = (props: Props) =>
{
    function getSubtitle() {
        if (props.customerType === PackageCustomerType.Private) {
            return (
                <div className='title-bar-subtitle'>
				    <div className="home-offers-view-subtitle">Scegli il pacchetto che più si adatta alle tue esigenze.</div>
				    <div className="home-offers-view-subtitle">
                        Costi di attivazione dilazionati, upload veloce, garanzia ZERO PENSIERI…<br></br>
                        A te non resta che scoprire il modo più semplice, sicuro, veloce per connettere te e la tua casa.
				    </div>
                </div>
            )
        }

        if (props.customerType === PackageCustomerType.Professional) {
            return (
                <div className='title-bar-subtitle'>
                    <div className="professional-offers-view-subtitle">
                        DigitalReti mette a disposizione dei piani specifici per i liberi professionisti, sia in rete Wireless che via cavo.<br></br>
                    </div>
                    <div className="professional-offers-view-subtitle"> 
                        Richiedi informazioni compilando il modulo e sarai ricontattato per trovare la soluzione adatta alle tue esigenze.
                    </div>
                </div>
            )
        }

        if (props.customerType === PackageCustomerType.Business) {
            return (
                <div className='title-bar-subtitle'>
                    <div className="enterprise-offers-view-subtitle">
                        DigitalReti mette a disposizione dei piani specifici per le aziende, sia in rete Wireless che via cavo.<br></br>
                    </div>
                    <div className="professional-offers-view-subtitle">
                        Richiedi informazioni compilando il modulo e sarai ricontattato per trovare la soluzione adatta alle tue esigenze.
                    </div>
                </div>
            )
        }
    }

	return (
        <div>
            <div className="titleBar-main-container" >
                <div className='titleBar-title'>
                    {props.title}
                    {getSubtitle()}
                </div>
                <img className='titleBar-image' src={`${props.imageSrc}`} alt='title-image'></img>
            </div>
            <div className='bottom-line'/>
        </div>
	)
}

export default TitleBar
